import styled from 'styled-components'
import React from 'react'
import { CookieConsentModal } from 'components/styled/cookie-consent/modal'

export const PageWidthLimitter = styled.div<{
  $isInUserManagement?: boolean
  $isInLive?: boolean
}>`
  max-width: ${({ theme, $isInLive }) =>
    $isInLive ? '100vw' : theme.size.pageMaxWidth};
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
  overflow: ${({ $isInUserManagement }) =>
    $isInUserManagement ? 'hidden' : 'visible'};
  display: flex;
  flex-direction: column;
`

export const WholePageContent = styled.div<{ $noMarginBottom?: boolean }>`
  flex-grow: 1;
  margin-bottom: ${({ theme, $noMarginBottom }) =>
    $noMarginBottom ? '0' : theme.space.s40};
`

export const StyledActionBarRoot = styled.div`
  margin: 0 auto;
  position: relative;
  max-width: ${({ theme }) => theme.size.pageMaxWidth};
  position: sticky;
  bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.actionBar};
`

export const ACTION_BAR_ROOT_ID = 'action-bar-root'

export const getActionBarRoot = () => {
  return document.getElementById(ACTION_BAR_ROOT_ID)
}

export const AppContent: React.FC<{
  footer?: React.ReactNode
  isInUserManagement?: boolean
  children?: React.ReactNode
  isInLive?: boolean
}> = ({ children, footer, isInUserManagement = false, isInLive = false }) => {
  return (
    <>
      <PageWidthLimitter
        id="app-content-width-limitter"
        $isInLive={isInLive}
        $isInUserManagement={isInUserManagement}
      >
        <WholePageContent $noMarginBottom={isInLive}>
          {children}
        </WholePageContent>
        {footer}
      </PageWidthLimitter>
      <StyledActionBarRoot id={ACTION_BAR_ROOT_ID} />
      <CookieConsentModal />
    </>
  )
}
